var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'יש לנו כמה שאלות...',"text":'כדי להכין לך תזרים מדויק, נצטרך תשובות לכמה שאלות. זה יקח רק דקה.',"notification-buttons":[
                      {
                        title:'לדיוק התזרים',
                        variant: 'primary',
                        size: 'slim',
                        action: _vm.openInvestigation,
                      } ],"icon-type":'warning'}}),_vm._v(" "),(_vm.openMergeInvestigationFlow)?_c('merge-investigation-flow',{on:{"done":_vm.onDoneInvestigation,"close":_vm.closeInvestigation}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }